import React from 'react';
import {
  CircularProgress,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Stack,
  Typography,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import FullScreenDialog from '../../../components/FullScreenDialog';
import { useLeadListsQuery } from '../hooks/useLeadsQuery';
import { AddAvatar } from './Leads.ListLeadItems';

// Tela "Listas" (como a do WhatsApp): criar uma lista nova e ver/gerenciar as
// listas do colaborador. Tocar numa lista abre o mesmo diálogo de edição do
// "Gerenciar"; a edição abre por cima e, ao fechar, volta para cá.
const LeadsListsManagerDialog = ({ open, onClose, onCreate, onManage }) => {
  const { t } = useTranslation();
  const { data: lists = [], isLoading } = useLeadListsQuery();

  return (
    <FullScreenDialog open={open} onClose={onClose} title={t('leads.lists.title')} maxWidth="sm">
      <List disablePadding>
        <ListItemButton onClick={onCreate} sx={{ px: 0 }}>
          <ListItemAvatar>
            <AddAvatar><AddIcon /></AddAvatar>
          </ListItemAvatar>
          <ListItemText primary={t('leads.lists.create')} />
        </ListItemButton>
      </List>

      {isLoading ? (
        <Stack alignItems="center" py={3}>
          <CircularProgress size={24} />
        </Stack>
      ) : (
        <List
          disablePadding
          subheader={(
            <ListSubheader disableGutters sx={{ bgcolor: 'transparent' }}>
              {t('leads.lists.yourLists')}
            </ListSubheader>
          )}
        >
          {lists.length === 0 && (
            <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
              {t('leads.lists.empty')}
            </Typography>
          )}
          {lists.map((list) => {
            const count = list.leads?.length ?? 0;
            return (
              <ListItemButton key={list.uuid} onClick={() => onManage(list)} sx={{ px: 0 }}>
                <ListItemText
                  primary={list.name}
                  secondary={count ? t('leads.lists.leadCount', { count }) : t('leads.lists.addLeads')}
                />
              </ListItemButton>
            );
          })}
        </List>
      )}
    </FullScreenDialog>
  );
};

export default LeadsListsManagerDialog;
